/* eslint-disable no-console */
import { Injectable, ErrorHandler, inject } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { NotifyService } from "./notify.service";
import { environment } from "@env/environment";

@Injectable({
  providedIn: "root"
})
export class GlobalErrorHandlerService implements ErrorHandler {
  private ns = inject(NotifyService);

  handleError(error: Error | HttpErrorResponse): void {
    if (error instanceof HttpErrorResponse) {
      console.group("HttpErrorResponse");
      if (!navigator.onLine) {
        this.logError("No Internet Connection! Cannot invoke " + error.url);
      } else {
        this.logError("Invoked url: ", error.url);
      }
      this.logError("Backend returned status code: ", error.status);
      this.logError("Response body:", error.message);
      this.logError("Full HttpErrorResponse:", error);
      console.groupEnd();
    } else {
      console.group("Error");
      this.logError(error.message);
      this.logError(error.stack);
      console.groupEnd();
    }

    if (!environment.production) {
      this.ns.applicationError("OOPS! Something went wrong . . . . . . . . . " + error.name + " : " + error.message);
    }
  }

  /**
   * logError()
   * @param message
   * @param opts
   */
  private logError(message: string, ...opts: any[]) {
    const errDate = new Date();
    console.error("[" + errDate.toLocaleString() + "] " + message, opts);

    if (navigator.onLine) {
      // TODO: Send a log to the server
    }
  }
}
